import ExtraTrayOptionsField from './ExtraTrayOptionsField';

export const EXAMPLE_ATTRIBUTE_NAME = 'example_attribute';
export const EXTRA_TRAY_OPTIONS_ATTRIBUTE_NAME = 'extra_tray_options';

// Map of custom_system_name ("Attribute Name" from the form builder) -> component
const overrides = {
  [EXTRA_TRAY_OPTIONS_ATTRIBUTE_NAME]: ExtraTrayOptionsField
};

export const getCustomFieldOverride = customSystemName => {
  if (!customSystemName) return null;
  return overrides[String(customSystemName).trim()] || null;
};
